export default "__VITE_ASSET__Btxhf1pq__"